import React, { useState } from "react";
import "./index.scss";

import { useUpdateQuoteMutation } from "store/quote/quoteApi";

import CustomActionMenu from "@components/CustomActionMenu/CustomActionMenu";
import StatusDropdown from "@components/StatusDropdown/StatusDropdown";
import { PATHS } from "config/paths";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import UpdateQuoteModal from "./UpdateQuoteModal/UpdateQuoteModal";
import PreviewPdfModal from "@components/PreviewPdfModal/PreviewPdfModal";
import { useSelector } from "react-redux";

const QuoteList = ({ quotes }) => {
  const navigate = useNavigate();
  const [showPreview, setShowPreview] = useState(false);
  const [quoteDate, setQuoteData] = useState(false);

  const [openMenuId, setOpenMenuId] = useState(null);
  const [modalQuote, setModalQuote] = useState(null);
  const [modalFields, setModalFields] = useState({});
  const [updateQuote] = useUpdateQuoteMutation();

  const currentUser = useSelector((state) => state.auth.user);

  const handleOpenModal = (quote) => {
    setModalQuote(quote);
    setModalFields(quote);
    setOpenMenuId(null);
  };

  const handleCloseModal = () => {
    setModalQuote(null);
  };

  const handleModalSave = async (data) => {
    if (!modalQuote) return;
    try {
      await updateQuote({ ...data, id: data?._id }).unwrap();
      toast.success(t("quote.updated!"));

      setTimeout(() => {
        navigate(PATHS.QUOTES.LIST);
      }, 1000);
      handleCloseModal();
    } catch (error) {
      console.log("erreur:", error?.data?.message);
    }
  };

  const actionMenu = (quote) => {
    console.log("🚀 ~ actionMenu ~ quote:", quote);
    const actions = [];

    // Edit quote
    if (
      currentUser?.roleId?.permissions.includes("UPDATE_QUOTE") &&
      quote?.status === "pending"
    ) {
      actions.push({
        label: t("quote.edit"),
        onClick: () => handleOpenModal(quote),
      });
    }

    // View / preview quote

    actions.push({
      label: t("quote.consult"),
      onClick: () => {
        setShowPreview(true);
        setOpenMenuId(null);
        setQuoteData(quote);
      },
    });

    return actions.length > 0 ? (
      <CustomActionMenu
        data={quote}
        actions={actions}
        openMenuId={openMenuId}
        setOpenMenuId={setOpenMenuId}
      />
    ) : null;
  };

  // Vérifie si l'utilisateur a au moins une permission sur les devis
  const hasActionPermission = ["UPDATE_QUOTE"].some((perm) =>
    currentUser?.roleId?.permissions.includes(perm)
  );
  const statusOptions = ["pending", "accepted", "refused", "invoiced"];

  const getStatusClass = (status) => {
    switch (status) {
      case "pending":
        return "status-badge status-pending";
      case "accepted":
        return "status-badge status-accepted";
      case "refused":
        return "status-badge status-refused";
      case "invoiced":
        return "status-badge status-invoiced";
      default:
        return "status-badge";
    }
  };
  return (
    <div style={{ overflowX: "auto" }}>
      <table className="invoice-table">
        <thead>
          <tr>
            <th style={{ width: "240px" }}>{t("quote.number")}</th>
            <th>{t("quote.client")}</th>
            <th>{t("quote.startDate")}</th>
            <th>{t("quote.amountHT")}</th>
            <th>{t("quote.tva")}</th>
            <th>{t("quote.amountTTC")}</th>
            <th>{t("quote.status")}</th>
            <th>{t("quote.validity")}</th>
            <th>{t("quote.dueDate")}</th>
            <th>{t("quote.paymentDeadline")}</th>
            <th style={{ width: "150px" }}>{t("invoice.invoice")}</th>
            <th>{t("quote.actions")}</th>
          </tr>
        </thead>
        <tbody>
          {quotes.map((quote) => (
            <tr key={quote._id}>
              <td style={{ width: "240px" }}>{quote.numeroDevis}</td>
              <td>{quote.clientName || quote.idClient?.name || "—"}</td>
              <td>
                {quote.startDate
                  ? new Date(quote.startDate).toLocaleDateString()
                  : "—"}
              </td>
              <td>{quote.totalHT?.toFixed(2) || "0.00"}</td>
              <td>{quote.tvaRate || "—"}</td>
              <td>{quote.totalTTC?.toFixed(2) || "0.00"}</td>

              <td>
                {hasActionPermission ? (
                  <StatusDropdown quote={quote} />
                ) : (
                  <span className={getStatusClass(quote.status)}>
                    {quote.status || "—"}
                  </span>
                )}
              </td>

              <td>{quote.validityPeriod || "—"}</td>
              <td>
                {quote.issueDate
                  ? new Date(quote.issueDate).toLocaleDateString()
                  : "—"}
              </td>
              <td>{quote.paymentDeadline || "—"}</td>
              <td style={{ width: "150px" }}>
                {quote?.invoiceId ? quote?.invoiceId?.numeroInvoice : "-"}
              </td>
              <td>{actionMenu(quote)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Modal édition devis */}
      <UpdateQuoteModal
        handleCloseModal={handleCloseModal}
        handleModalSave={handleModalSave}
        modal={modalQuote}
        title={t("quote.update")}
        isUpdate={true}
        modalFields={modalFields}
      />

      {/* Modal preview devis */}
      <PreviewPdfModal
        previewInvoiceData={quoteDate}
        setShowPreview={setShowPreview}
        showPreview={showPreview}
        isQuote={true}
        title={t("quote.preview")}
      />
    </div>
  );
};

export default QuoteList;
